export const OPEN_LAUNCHER = 'OPEN_LAUNCHER';
export const CLOSE_LAUNCHER = 'CLOSE_LAUNCHER';

export const LAUNCHER_COMMAND_CHAR = '/';

export const LAUNCHER_RESULT_TYPES = {
    BOARD: 'BOARD',
    COMMAND: 'COMMAND',
};
